import { render, staticRenderFns } from "./CrearClienteProveedorModal.vue?vue&type=template&id=e7cfa962&"
import script from "./CrearClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./CrearClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports